export const GALabels = {
  // Interstitials

  BrexOfferStarted: 'offer_2_start',
  BrexOfferPostponed: 'offer_2_close',
  BrexOfferDeclined: 'offer_2_no_thanks',

  // Navigation
  NavProfile: 'account_nav_profile',
  NavResources: 'account_nav_resources',
  NavSignOut: 'account_nav_sign_out',
  NavContactUs: 'account_nav_contact_us',

  // Business Toolkit
  BusinessToolkitNav: 'business_toolkit_click',
  BusinessToolkitViewServices: 'business_toolkit_view_services',
  BusinessToolkitWixLearnMore: 'business_toolkit_wix_learnmore',

  BusinessToolkitBOALearnMore: 'business_toolkit_boa_learnmore',

  BusinessToolkitNEXTLearnMore: 'business_toolkit_next_learnmore',
  BusinessToolkitSquareLearnMore: 'business_toolkit_square_learnmore',
  BusinessToolkitGoogleLearnMore: 'business_toolkit_google_learnmore',
  BusinessToolkitLegalLearnMore: 'business_toolkit_legal_forms_learnmore',
  BusinessToolkitTrademarkLearnMore: 'business_toolkit_trademark_learnmore',
  BusinessToolkitEPLearnMore: 'business_toolkit_ep_learnmore',

  // Insurance - Next - task drawer
  InsuranceNextDefault: 'insurance_next_default',
  InsuranceNextEntitled: 'insurance_next_entitled',
  InsuranceNextCompleted: 'insurance_next_completed',

  InsuranceNextPrimaryDefault: 'insurance_next_drawer_default_cta_click',
  InsuranceNextSecondaryDefault:
    'insurance_next_drawer_default_do_it_myself_click',
  InsuranceNextSecondaryAltDefault:
    'insurance_next_drawer_default_learn_more_click',

  InsuranceNextPrimaryEntitled: 'insurance_next_drawer_entitled_cta_click',

  InsuranceNextPrimaryCompleted:
    'insurance_next_drawer_completed_cta_account_create_click',
  InsuranceNextSecondaryCompleted:
    'insurance_next_drawer_completed_cta_more_time_click',

  // Insurance - NEXT - category page
  INSURANCE_NEXT_CATEGORY_PAGE_DEFAULT: 'insurance_next_category_page_default',
  INSURANCE_NEXT_CATEGORY_PAGE_ENTITLED:
    'insurance_next_category_page_entitled',
  INSURANCE_NEXT_CATEGORY_PAGE_COMPLETED:
    'insurance_next_category_page_completed',
  INSURANCE_NEXT_CATEGORY_PAGE_DEFAULT_CTA_CLICK:
    'insurance_next_category_page_default_cta_click',
  INSURANCE_NEXT_CATEGORY_PAGE_ENTITLED_CTA_CLICK:
    'insurance_next_category_page_entitiled_cta_click',

  // Login Page
  AuthSignIn: 'auth_signin',
  AuthSignUp: 'auth_signup',
  AuthCreateAnAccount: 'auth_create_account',
  AuthForgotPasswordConfirm: 'auth_forgot_password_confirm',
  AuthReturnToForgetPassword: 'click try again to return to forgot password',
  AuthForgotPassword: 'auth_forgot_password',
  AuthSendPasswordReset: 'auth_send_password_reset',
  AuthChangePassword: 'auth_change_password',
  AuthChangePasswordSuccess: 'auth_change_password_success',

  // Mfa
  MfaAddEnrollment: 'add_enrollment',
  MfaEnterCode: 'enter_code',
  MfaResend: 'resend_code',
  MfaIdentityVerification: 'identity_verification',
  MfaIdentityVerificationSuccess: 'identity_verification_success',
  MfaIdentityVerificationFailed: 'identity_verification_failed',
  MfaGetHelp: 'identity_verification_get_help',
  MfaAgentWillReachOut: 'identity_verification_agent_will_reach_out',

  // Testing Only
  Test: 'test',
  TestAlt: 'test alt',

  // Business Email - Google Workspace
  BusinessEmailCategoryPageDefault: 'business_email_category_page_default',
  BusinessEmailCategoryPageEntitled: 'business_email_category_page_entitled',
  BusinessEmailCategoryPageCompleted: 'business_email_category_page_completed',
  BusinessEmailSeatsModalDefault: 'business_email_seats_modal_default',
  BusinessEmailRyoModalDefault: 'business_email_ryo_modal_default',
  BusinessEmailCategoryPageDefaultGetStartedClick:
    'business_email_category_page_default_get_started_click',
  BusinessEmailCategoryPageDefaultBusinessStarterClick:
    'business_email_category_page_default_business_starter_click',
  BusinessEmailCategoryPageDefaultBusinessStandardClick:
    'business_email_category_page_default_business_standard_click',
  BusinessEmailSeatsModalDefaultCtaClick:
    'business_email_seats_modal_default_cta_click',
  BusinessEmailRyoModalDefaultCtaClick:
    'business_email_ryo_modal_default_cta_click',
  BusinessEmailRyoModalDefaultBackClick:
    'business_email_ryo_modal_default_back_click',
  BusinessEmailCategoryPageEntitledCtaClick:
    'business_email_category_page_entitled_cta_click',
  BusinessEmailCategoryPageEntitledLearningCenterClick:
    'business_email_category_page_entitled_learning_center_click',
  BusinessEmailCategoryPageEntitledCustomerCareClick:
    'business_email_category_page_entitled_customer_care_click',
  BusinessEmailCategoryPageEntitledManageSubscriptionClick:
    'business_email_category_page_entitled_manage_subscription_click',
  BusinessEmailCategoryPageCompletedCtaClick:
    'business_email_category_page_completed_cta_click',
  BusinessEmailCategoryPageCompletedLearningCenterClick:
    'business_email_category_page_completed_learning_center_click',
  BusinessEmailCategoryPageCompletedCustomerCareClick:
    'business_email_category_page_completed_customer_care_click',
  BusinessEmailCategoryPageCompletedManageSubscriptionClick:
    'business_email_category_page_completed_manage_subscription_click',

  // Homepage
  HomeOrdersPaidStart: 'account_orders_paid_start',
  HomeOrdersNeedsAction: 'account_orders_needs_action',
  HomeOrdersPaidResume: 'account_orders_paid_resume',
  HomeOrdersUnpaidResume: 'account_orders_unpaid_resume',
  HomeOrdersUnpaidRemove: 'account_orders_unpaid_remove',
  HomeOrdersUnpaidRemoveConfirm: 'account_orders_unpaid_remove_confirm',
  HomeOrdersUnpaidRemoveDismiss: 'account_orders_unpaid_remove_dismiss',
  HomeOrdersView: 'account_orders_view',
  HomeOrdersViewDocs: 'account_orders_view_docs',
  HomeOrdersUpdatePayment: 'account_orders_update_payment',
  HomeOrdersActivate: 'account_orders_activate',
  HomeOrdersAdviceTax: 'account_orders_advice_tax',
  HomeOrdersAdviceLegal: 'account_orders_advice_legal',
  HomeOrdersViewMore: 'account_orders_view_more',
  SeeOrderProgress: 'account_order_full_details',
  HomeOrderReceipt: 'account_order_slider_receipt',

  // Order Status
  ContactUs: 'account_order_slider_contact',
  Docs: 'account_order_slider_documents',
  EnterDetails: 'account_order_slider_fix',
  TrackPackage: 'account_order_slider_track_package',
  UpdatePayment: 'account_order_slider_update_payment',

  // Orders
  OrdersDeleteCart: 'orders_delete_cart',

  // Email Workspace - Google
  EmailDrawerDefault: 'business_email_drawer_default',
  EmailPrimaryDefault: 'business_email_drawer_default_cta_click',
  EmailSecondaryDefault: 'business_email_drawer_default_do_it_myself_click',

  EmailDrawerEntitled: 'business_email_drawer_entitled',
  EmailPrimaryEntitled: 'business_email_drawer_entitled_cta_click',
  EmailSecondaryEntitled: 'business_email_drawer_entitled_ill_this_later_click',

  EmailDrawerPending: 'business_email_drawer_pending',
  EmailPrimaryPending: 'business_email_drawer_pending_cta_click',

  EmailDrawerCompleted: 'business_email_drawer_completed',
  EmailPrimaryCompleted: 'business_email_drawer_completed_cta_click',
  EmailSecondaryCompleted:
    'business_email_drawer_completed_cta_more_time_click',
  EmailAccessEmailCompleted:
    'business_email_drawer_completed_access_email_click',
  EmailMakeChangesCompleted:
    'business_email_drawer_completed_make_changes_click',

  EmailDrawerDismissed: 'business_email_drawer_dismissed',
  EmailPrimaryDismissed: 'business_email_drawer_dismissed_cta_click',
  EmailPurchaseDismissed: 'business_email_drawer_dismissed_purchase_click',

  // Banking - Bank Of America
  BankOfAmericaDrawerDefault: 'bank_of_america_drawer_default',
  BankOfAmericaDrawerEntitled: 'bank_of_america_drawer_entitled',
  BankOfAmericaDrawerCompleted: 'bank_of_america_drawer_completed',
  BankOfAmericaPrimaryDefault: 'bank_of_america_drawer_default_cta_click',
  BankOfAmericaSecondaryDefault:
    'bank_of_america_drawer_default_do_it_myself_click',
  BankOfAmericaPrimaryEntitled: 'bank_of_america_drawer_entitled_cta_click',
  BankOfAmericaPrimaryCompleted:
    'bank_of_america_drawer_completed_cta_account_create_click',
  BankOfAmericaSecondaryCompleted:
    'bank_of_america_drawer_completed_cta_more_time_click',

  // Website - Wix
  WebsiteDrawerDefault: 'website_drawer_default',
  WebsiteDrawerEntitled: 'website_drawer_entitled',
  WebsiteDrawerCompleted: 'website_drawer_completed',
  WebsitePrimaryDefault: 'website_drawer_default_cta_click',
  WebsiteSecondaryDefault: 'website_drawer_default_do_it_myself_click',
  WebsitePrimaryEntitled: 'website_drawer_entitled_cta_click',
  WebsitePrimaryCompleted: 'website_drawer_completed_cta_click',
  WebsiteSecondaryCompleted: 'website_drawer_completed_cta_account_create',

  // POS - Square
  PosSquareDrawerDefault: 'pos_square_drawer_default',
  PosSquareDrawerEntitled: 'pos_square_drawer_entitled',
  PosSquareDrawerCompleted: 'pos_square_drawer_completed',
  PosSquarePrimaryDefault: 'pos_square_drawer_default_cta_click',
  PosSquareSecondaryDefault: 'pos_square_drawer_default_do_it_myself_click',
  PosSquarePrimaryEntitled: 'pos_square_drawer_entitled_cta_click',
  PosSquareSecondaryEntitled: 'pos_square_drawer_entitled_do_it_myself_click',
  PosSquarePrimaryCompleted:
    'pos_square_drawer_completed_cta_account_create_click',
  PosSquareSecondaryCompleted:
    'pos_square_drawer_completed_cta_more_time_click',

  // Template - store
  StartTempQflow: 'start_temp_qflow',
  DownloadDoc: 'download_doc',
  sendEsign: 'send_esign',
  sentEsign: 'sent_esign',
  EditDoc: 'edit_doc',
  LegalHelpFromDoc: 'legal_help_from_doc',
  FePaynowClicked: 'fe_paynow_clicked',
  PreviewBannerRedirect: 'redirect_from_banner_cta',

  // Universal Checkout
  CheckoutApplyPromoCode: 'checkout_apply_promo_code',
  CheckoutClearPromoCodes: 'checkout_clear_promo_codes',
};

export type GALabels = (typeof GALabels)[keyof typeof GALabels];
